export default "__VITE_ASSET__fdc50ec3__"